import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 98,
      gap: 16,
      paddingTop: 16,
      paddingBottom: 16,
      fontWeight: 600,
      fontSize: 32,
      color: variables.richBlack,

      '@media (min-width: 1181px)': {
        display: 'none',
      },
    },
  }),
);
